<template>
  <div class="top">
    <div class="head-list scc-container">
      <div class="logo-group">
        <img src="https://cdn.huodongxing.com/web-meeting/img/logo2023.png" />
      </div>
      <el-menu :default-active="activeIndex"
               class="top-nav"
               mode="horizontal"
               @select="handleSelect">
        <el-menu-item index="home" @click="toanchor('/pages/index/index', 'app')">首页</el-menu-item>
        <!-- <el-menu-item index="guest" @click="toanchor('/pages/index/index','guest')">{{$t('message.guest')}}</el-menu-item> -->
        <el-menu-item index="schedule" @click="toanchor('/pages/forum/schedule')">
          日程
        </el-menu-item>
        <el-menu-item index="secondScene" @click="toanchor('/pages/secondScene/index', 'secondScene')">
          第二现场
        </el-menu-item>
        <el-menu-item index="exhibition" @click="toanchor('/pages/exhibition/index')">
          展会
        </el-menu-item>
        <el-menu-item index="participatnts" v-if="homeInfo.webLoadMenuPc.includes('3')" @click="toanchor('/pages/live/index', 'participatnts')">
          {{ i18nMessage.live }}
        </el-menu-item>
        <el-menu-item index="highlight" v-if="homeInfo.webLoadMenuPc.includes('4')" @click="toanchor('/pages/highlight/index', 'highlight')">
          {{ i18nMessage.highlight }}
        </el-menu-item>
        <el-menu-item index="news" v-if="homeInfo.webLoadMenuPc.includes('5')" @click="toanchor('/news')">
          {{ i18nMessage.news }}
        </el-menu-item>
        <el-menu-item index="guide" v-if="homeInfo.webLoadMenuPc.includes('6')" @click="toanchor('/pages/user/participantGuide')">
          参会指南
        </el-menu-item>
        <!-- <el-menu-item index="partner" @click="toanchor('/pages/index/index','partner')">{{$t('message.media')}}</el-menu-item> -->
        <el-menu-item index="about" v-if="homeInfo.webLoadMenuPc.includes('7')" @click="toanchor('/pages/user/aboutUs')">
          关于大会
        </el-menu-item>
      </el-menu>
      <div class="user-center" style="display: flex;align-items: center">
        <el-button v-if="!islogin"
                   class="joinBotton"
                   type="primary"
                   round
                   @click="gotojoinApply">报名参会</el-button>
        <!-- <el-button v-else
                   class="joinBotton"
                   type="primary"
                   round
                   @click="loginOut">退出登录</el-button> -->
        <el-menu v-else
                 class="el-menu-demo"
                 mode="horizontal">
          <el-submenu popper-class="user-center-menu" index="2-4" style>
            <!-- <template slot="title">Hi, {{$store.getters.name}}</template> -->
            <template slot="title"><img :src="userInfo.userLogo || 'https://cdn.huodongxing.com/hdx-wx/img/icon/login/user.png'" alt=""></template>
            <el-menu-item @click="goMySchedule" index="2-4-1" class="el-menu-poup">
              我的收藏
            </el-menu-item>
            <el-menu-item @click="loginOut" index="2-4-2" class="el-menu-poup is-end">
              <!-- <i class="el-icon-s-management"></i> -->
              退出登录
            </el-menu-item>
          </el-submenu>
        </el-menu>
        <!-- <div class="right" style>
          <a id="zn" :class="$i18n.locale == 'zh-CN'?'active':''" @click="change('zh-CN')">中文</a>
          <span>&nbsp; / &nbsp;</span>
          <a id="en" :class="$i18n.locale == 'en'?'active':''" @click="change('en')">EN</a>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { removeToken } from "../utils/auth";
import { mapGetters } from "vuex";

export default {
  inject: ["reload"],
  props: {
    index: {
      type: String,
      default: ""
    },
  },
  computed: {
    ...mapGetters({
      islogin: "token",
      isJoin: "isJoin",
      userInfo: "userInfo",
      homeInfo: 'homeInfo'
    }),
    i18nMessage() {
      return this.$t('message')
    },
  },
  data() {
    return {
      activeIndex: "home",
      show: false,
      name: localStorage.getItem("name"),
      eid: localStorage.getItem("eid"),
      phone: "",
      code: "",
    };
  },
  methods: {
    gotojoinApply() {
      hdxVue.$el['__vue__'].joinApply(true);
      // this.$parent.$parent.joinApply();
    },
    loginOut() {
      removeToken();
      window.localStorage.removeItem("name");
      localStorage.setItem("isJoin", 1);
      this.$store.dispatch("isJoin", 1);
      this.$store.dispatch("setToken", "");
      this.toanchor('/pages/index/index','app');
      this.activeIndex = 'home'
    },
    goMySchedule() {
      this.toanchor('/pages/forum/myforum');
    },
    handleSelect(key, keyPath) {
      localStorage.setItem("activeIndex", key);
    },
    change(lang) {
      this.$i18n.locale = lang;
      localStorage.lang = lang;
      this.$router.push({ path: this.$route.path, query: { lang: lang } });
      // this.reload()
    },

    // 登录
    toLogin() {
      this.$parent.$parent.centerDialogVisible = true;
    },
    // 个人中心页面
    gouser() {
      this.$router.history.push("/user");
    },
    // 进入直播厅
    gozbt(eid) {
      this.$router.push("/pages/live/index");
    },
    toanchor(path, selectId) {
      sessionStorage.setItem("toId", selectId);
      if (this.$route.path == path) {
        if (selectId) {
          this.getLocal();
        }
      } else {
        this.$router.push({ path: path });
        window.scrollTo(0, 0);
      }
    },
    getLocal() {
      let selectId = sessionStorage.getItem("toId");
      let toElement = document.getElementById(selectId);
      if (selectId) {
        toElement.scrollIntoView();
      } else {
        window.scrollTo(0, 0);
      }
    }
  },
  created() {
    // if (this.$route.path == "/pages/index/index") {
    this.activeIndex = this.index ? this.index : 
          localStorage.getItem("activeIndex")
          ? localStorage.getItem("activeIndex")
          : "home";
    // }
  },
};
</script>
<style lang="less">
  .top-nav.el-menu {
    height: 100%;
    border: none;
    background-color: transparent;

    .el-menu-item {
      height: 100%;
      border: none;
      color: rgba(255, 255, 255, 0.8);
      line-height: 80px;
      &:hover,
      &:focus,
      &.is-active {
        background: linear-gradient(180deg, #3d32ba 0%, #130d38 100%);
        color: #92e8ff;
      }
    }

    .el-submenu {
      &.is-opened {
        .el-submenu__title {
          color: #59bd1a;
        }
      }

      height: 100%;

      .el-submenu__title {
        height: 100%;
        line-height: 100px;
        border: none;

        &.is-active {
          border: none;
        }
      }
    }
  }

  .user-center {
    .el-menu--horizontal {
      border: none;

      .el-submenu {
        &.is-active {
          .el-submenu__title {
            border: none;
            color: #59bd1a;
            i {
              color: #59bd1a;
            }
          }
        }

        &.is-opened {
          .el-submenu__title {
            color: #59bd1a;

            i {
              color: #59bd1a;
            }
          }
        }
      }
    }
  }

  .user-center-menu {
    // display: inline-block !important;
    width: 88px !important;
    background: #ffffff !important;
    border-radius: 8px !important;
    overflow: hidden;
    .el-menu--popup {
      width: 100%;
      min-width: 100%;
      margin: 0;
      padding: 0;
      .el-menu-poup {
        font-size: 14px;
        line-height: 40px;
        height: 40px;
        color: #999999;
        padding: 0 12px;
        text-align: center;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          width: calc(100% - 24px);
          height: 1px;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          border-bottom: 1px solid #eeeeee;
        }
        &:hover {
          color: #4c4bff;
        }
        &.is-end {
          &::after {
            content: none;
          }
        }
      }
    }
    &.el-menu--horizontal {
      .el-menu {
        .el-menu-item {
          border: none;

          &.is-active {
            color: #59bd1a;
            border: none;
          }
        }
      }
    }
  }
  .el-menu-demo {
    background-color: transparent !important;
    display: inline-block;
    height: 40px;
    img {
      width: 40px;
      height: 40px;
      overflow: hidden;
      border-radius: 50%;
      display: inline-block;
    }
    .el-submenu__icon-arrow {
      display: inline-block;
    }
    &:hover,
    .el-submenu,
    .el-submenu__title {
      background-color: transparent !important;
      display: inline-block;
      height: 40px !important;
      line-height: 40px !important;
    }
  }
</style>
<style lang="less" scoped>
  @import '@/style/variable.less';
  .joinBotton {
    display: block;
    height: 26px;
    padding: 0 12px;
    border: none;
    background: #ea3b7f;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 26px;
  }
  .top {
    font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', Helvetica,
      Arial, 'Hiragino Sans GB', 'Source Han Sans', 'Noto Sans CJK Sc', 'Microsoft YaHei',
      'Microsoft Jhenghei', sans-serif;
    display: flex;
    width: 100%;
    height: 80px;
    background: #000;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
    justify-content: space-around;
    align-items: center;
    z-index: 1000;

    .head-list {
      width: 100%;
      min-width: 1080px;
      max-width: 1920px;
      height: 80px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .logo-group {
      margin-left: 100px;
      flex: 1 0 430px;

      img {
        display: inline-block;
        height: 30px;

        &:first-child {
          margin-right: 40px;
        }
      }
    }

    .user-center {
      margin: 0 20px;
    }

    .right {
      display: inline-block;
      height: 60px;
      font-size: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: #ffffff;
      span {
        margin: 0 5px;
      }
      a {
        cursor: pointer;
        white-space: nowrap;
        &:hover {
          color: rgba(170, 170, 170, 1);
        }
      }

      .active {
        color: rgb(90, 181, 96);
        &:hover {
          color: rgb(90, 181, 96);
        }
      }
    }
  }
</style>
